import {IComponentOptions} from "angular";
import {AccessLevelToggle} from "../../model/AccessLevelToggle";
import {AccessLevelConfig} from "../../model/AccessLevelConfig";


export class AccessLevelToggleComponent {

    static instance: IComponentOptions = {
        template: require('./access-level-toggle.component.html'),
        controller: [AccessLevelToggleComponent],
        bindings: {
            'accessLevel': '=',
            accessLevelConfig: '<'
        }
    };

    private accessLevel:AccessLevelToggle;
    private accessLevelConfig: AccessLevelConfig;

    $onInit() {
        this.accessLevelConfig = this.accessLevelConfig || {
            disabled: false
        }
    }

}